module.exports = __webpack_public_path__ + "img/67dea62.png";